import { render, staticRenderFns } from "./Vfus.vue?vue&type=template&id=78f3f3b8"
import script from "./Vfus.vue?vue&type=script&lang=js"
export * from "./Vfus.vue?vue&type=script&lang=js"
import style0 from "./Vfus.vue?vue&type=style&index=0&id=78f3f3b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports